import { FC, useMemo } from 'react';

import { useTour } from '@reactour/tour';
import { useFormikContext } from 'formik';
import { Tabs } from 'ui/components/nav';
import { SIZE } from 'utils/constants';

import { EVENT_FORM } from '../schema';

const TAB_ITEMS = [
  { label: 'VIRTUAL', value: 'VIDEO' },
  { label: 'ON SITE', value: 'EVENT' },
  { label: 'MOBILE CALL', value: 'CALL' },
];

const EventType: FC = () => {
  const { values, setFieldValue } = useFormikContext<EVENT_FORM>();
  const { isOpen } = useTour();

  const items = useMemo(() => {
    if (isOpen) {
      return TAB_ITEMS.map((item) => ({ ...item, disabled: true }));
    }

    return TAB_ITEMS;
  }, [isOpen]);

  return (
    <div className="flex py-3">
      <Tabs
        size={SIZE.Small}
        type="tertiary"
        items={items}
        onChange={(val) => setFieldValue('type', val.value)}
        selectedTab={values.type}
      />
    </div>
  );
};

export default EventType;
